<body [ngClass]="{'waiting': loading_data} ">
  <cdk-virtual-scroll-viewport (scroll)="scrolled($event)" itemSize="16" class="example-viewport">
    <div [style.top]="inverseOfTranslation" class="sticky-header box">
      <div>
        <div class="header small">UID</div>
        <div class="header small">Uploaded</div>
        <div class="header medium">Serial No</div>
        <div class="header small">Postcode</div>
        <div class="header small">Job Id</div>
        <div class="header medium">Created On</div>
        <div class="header medium">Assigned On</div>
        <div class="header large">First Name</div>
        <div class="header large">Last Name</div>
        <div class="header xlarge">Address 1</div>
        <div class="header xlarge">Address 2</div>
        <div class="header xlarge">Address 3</div>
        <div class="header small">City</div>
        <div class="header medium">Job PostCode</div>
        <div class="header medium">Contact Phone</div>
        <div class="header medium">Contact Mobile</div>
        <div class="header large">Contact Email</div>
        <div class="header large">Start Time</div>
        <div class="header large">End Time</div>
        <div class="header medium">Status</div>
        <div class="header xlarge">Notes</div>
        <div class="header medium">MPRN</div>
        <div class="header small">Eircode</div>
        <div class="header medium">Scan Serial of Hub</div>
        <div class="header medium">Enter Serial of Hub</div>
        <div class="header large">Start Job</div>
        <div class="header medium">GPRN</div>
        <div class="header large">Last Updated</div>
        <div class="header large">Geopal Data</div>
        <div class="header small">Process Error</div>
        <div class="header large">Assigned To</div>
        <div class="header large">Installer Id</div>
        <div class="header medium">Date Corrected</div>
        <div class="header medium">Unique Id</div>
      </div>
      <div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.uid">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('uid')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.uploaded">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('uploaded')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.serial_no">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('serial_no')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.post_code">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('post_code')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.job_id">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('job_id')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.created_on">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('created_on')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.assigned_date_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('assigned_date_time')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.first_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('first_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.last_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('last_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.address_line_1">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('address_line_1')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput class="input-style" [(ngModel)]="searchParams.address_line_2">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('address_line_2')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.address_line_3">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('address_line_3')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.city">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('city')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.job_postal_code">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('job_postal_code')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.contact_phone">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('contact_phone')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true"
                [(ngModel)]="searchParams.contact_mobile">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('contact_mobile')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true"
                [(ngModel)]="searchParams.contact_email">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('contact_email')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true"
                [(ngModel)]="searchParams.start_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('start_time')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true"
                [(ngModel)]="searchParams.end_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('end_time')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.status">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('status')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.notes">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('notes')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.mprn">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('mprn')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.eircode">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('eircode')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style"
                [(ngModel)]="searchParams.scan_serial_number_of_hub">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('scan_serial_number_of_hub')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style"
                [(ngModel)]="searchParams.entered_serial_number_of_hub">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('entered_serial_number_of_hub')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.start_job">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('start_job')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.gprn">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('gprn')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style"
                [(ngModel)]="searchParams.last_updated_date_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('last_updated_date_time')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.geopal_data">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('geopal_data')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.process_error">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('process_error')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.assignedto">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('assignedto')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.installerid">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('installerid')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.date_corrected">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('date_corrected')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.unique_id">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('unique_id')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row box" *cdkVirtualFor="let install of installsList; let index = index"
      [style.background-color]="this.getColor(index)">
      <div class="column-first small">{{install.uid}}</div>
      <div class="column small">{{install.uploaded}}</div>
      <div class="column medium"><input matInput class="medium_input" id="next_serial_no" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.serial_no, $event.srcElement.id)"
          [value]="install.serial_no" [(ngModel)]="install.serial_no"></div>
      <div class="column small"><input matInput class="small_input" id="next_post_code" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.post_code, $event.srcElement.id)"
          [value]="install.post_code" [(ngModel)]="install.post_code"></div>
      <div class="column small">{{install.job_id}}</div>
      <div class="column medium">{{install.created_on}}</div>
      <div class="column medium">{{install.assigned_date_time}}</div>
      <div class="column large">
        <input matInput class="large_input" id="next_first_name" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.first_name, $event.srcElement.id)"
          [value]="install.first_name" [(ngModel)]="install.first_name"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_last_name" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.last_name, $event.srcElement.id)"
          [value]="install.last_name" [(ngModel)]="install.last_name"></div>
      <div class="column xlarge"><input matInput class="xlarge_input" id="next_address_line_1"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.address_line_1, $event.srcElement.id)"
          [value]="install.address_line_1" [(ngModel)]="install.address_line_1"></div>
      <div class="column xlarge"><input matInput class="xlarge_input" id="next_address_line_2"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.address_line_2, $event.srcElement.id)"
          [value]="install.address_line_2" [(ngModel)]="install.address_line_2"></div>
      <div class="column xlarge"><input matInput class="xlarge_input" id="next_address_line_3"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.address_line_3, $event.srcElement.id)"
          [value]="install.address_line_3" [(ngModel)]="install.address_line_3"></div>
      <div class="column small"><input matInput class="small_input" id="next_city" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.city, $event.srcElement.id)" [value]="install.city"
          [(ngModel)]="install.city"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_job_postal_code"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.job_postal_code, $event.srcElement.id)"
          [value]="install.job_postal_code" [(ngModel)]="install.job_postal_code"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_contact_phone"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.contact_phone, $event.srcElement.id)"
          [value]="install.contact_phone" [(ngModel)]="install.contact_phone"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_contact_mobile"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.contact_mobile, $event.srcElement.id)"
          [value]="install.contact_mobile" [(ngModel)]="install.contact_mobile"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_contact_email" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.contact_email, $event.srcElement.id)"
          [value]="install.contact_email" [(ngModel)]="install.contact_email"></div>
      <div class="column large">{{install.start_time}}</div>
      <div class="column large">{{install.end_time}}</div>
      <div class="column medium">{{install.status}}</div>

      <div class="column xlarge"><input matInput class="xlarge_input" id="next_notes" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.notes, $event.srcElement.id)" [value]="install.notes"
          [(ngModel)]="install.notes"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_mprn" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.mprn, $event.srcElement.id)" [value]="install.mprn"
          [(ngModel)]="install.mprn"></div>
      <div class="column small"><input matInput class="small_input" id="next_eircode" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.eircode, $event.srcElement.id)" [value]="install.eircode"
          [(ngModel)]="install.eircode"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_scan_serial_number_of_hub"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.scan_serial_number_of_hub, $event.srcElement.id)"
          [value]="install.scan_serial_number_of_hub" [(ngModel)]="install.scan_serial_number_of_hub"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_entered_serial_number_of_hub"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.entered_serial_number_of_hub, $event.srcElement.id)"
          [value]="install.entered_serial_number_of_hub" [(ngModel)]="install.entered_serial_number_of_hub"></div>
      <div class="column large">{{install.start_job}}</div>
      <div class="column medium"><input matInput class="medium_input" id="next_gprn" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.gprn, $event.srcElement.id)" [value]="install.gprn"
          [(ngModel)]="install.gprn"></div>
      <div class="column large">{{install.last_updated_date_time}}</div>
      <div class="column-special large">Place Holder</div>
      <div class="column small">{{install.process_error}}</div>
      <div class="column large"><input matInput class="large_input" id="next_assignedto" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.assignedto, $event.srcElement.id)"
          [value]="install.assignedto" [(ngModel)]="install.assignedto"></div>
      <div class="column large"><input matInput class="large_input" id="next_installerid" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.installerid, $event.srcElement.id)"
          [value]="install.installerid" [(ngModel)]="install.installerid"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_date_corrected"
          (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.date_corrected, $event.srcElement.id)"
          [value]="install.date_corrected" [(ngModel)]="install.date_corrected"></div>
      <div class="column medium"><input matInput class="medium_input" id="next_unique_id" (keyup.enter)="keytab($event)"
          (change)="updateInstallation(install.uid, install.unique_id, $event.srcElement.id)"
          [value]="install.unique_id" [(ngModel)]="install.unique_id"></div>
    </div>
  </cdk-virtual-scroll-viewport>
</body>
